import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

import { lenis } from "../global/scroll";

gsap.registerPlugin(ScrollTrigger, SplitText);

export default class AnimationHandler {
	animations() {
		gsap.utils.toArray('[data-animate="opacity"]').forEach( (e) => {
			const delay =
				e.dataset.animateDelayDesktop ||
				e.dataset.animateDelayMobile ||
				(e.offsetTop < window.innerHeight ? e.dataset.animateDelay || "0.5" : e.dataset.animateDelay || "0");

			const duration =
				e.dataset.animateDurationDesktop ||
				e.dataset.animateDurationMobile ||
				e.dataset.animateDuration ||
				"2";

			const stagger =
				e.dataset.animateStaggerDesktop ||
				e.dataset.animateStaggerMobile ||
				e.dataset.animateStagger ||
				"0.1";

			// Calculate if element is above the fold
			const elementTop = e.getBoundingClientRect().top + window.scrollY;
			const isAboveFold = elementTop < window.innerHeight;

			var tl = gsap.timeline({
				scrollTrigger: {
					trigger: e,
					// start: isAboveFold ? "bottom bottom" : "top 90%",
					start: "top 90%",
				},
			});	
			tl.fromTo(e, {
				autoAlpha: 0,
			}, {
				autoAlpha: 1,
				ease: "power4.out",
				duration: duration,
				stagger: stagger,
				delay: delay,
			});
		});
		gsap.utils.toArray('[data-animate="text"]').forEach((e) => {
			document.fonts.ready.then(() => {
				const delay =
					e.dataset.animateDelayDesktop ||
					e.dataset.animateDelayMobile ||
					(e.offsetTop < window.innerHeight ? e.dataset.animateDelay || "0.5" : e.dataset.animateDelay || "0");
		
				const duration =
					e.dataset.animateDurationDesktop ||
					e.dataset.animateDurationMobile ||
					e.dataset.animateDuration ||
					"0.8";
		
				const stagger =
					e.dataset.animateStaggerDesktop ||
					e.dataset.animateStaggerMobile ||
					e.dataset.animateStagger ||
					"0";
		
				if (!e.matches('p, h1, h2, h3, h4, h5, h6, span, ul, li')) {
					gsap.utils.toArray(e.querySelectorAll('p, h1, h2, h3, h4, h5, h6, span, ul, li')).forEach((child) => {
						animateText(child, delay, duration, stagger);
					});
				} else {
					animateText(e, delay, duration, stagger);
				}
			});
			function animateText(element, delay, duration, stagger) {
				const inner = new SplitText(element, {
					type: "lines, words",
					linesClass: "lines--inner"
				});
				const outer = new SplitText(element, {
					type: "lines, words",
					linesClass: "lines--outer"
				});

				// Calculate if element is above the fold
				const elementTop = element.getBoundingClientRect().top + window.scrollY;
				const isAboveFold = elementTop < window.innerHeight;

				const tl = gsap.timeline({
					scrollTrigger: {
						trigger: element,
						start: isAboveFold ? "bottom bottom" : "bottom 90%",
					},
					onComplete: () => {
						outer.revert();
						inner.revert();
					}
				});
			
				tl.set(element, { opacity: 1 });
				tl.fromTo(
					inner.lines,
					{
						yPercent: -100,
						opacity: 0,
					},
					{
						yPercent: 0,
						opacity: 1,
						ease: "power4.out",
						duration: duration,
						stagger: stagger,
						delay: delay,
					}
				);
			}
		});
		
		gsap.utils.toArray('[data-animate="scale"]').forEach( (e) => {
			const delay =
				e.dataset.animateDelayDesktop ||
				e.dataset.animateDelayMobile ||
				(e.offsetTop < window.innerHeight ? e.dataset.animateDelay || "0.5" : e.dataset.animateDelay || "0");

			const duration =
				e.dataset.animateDurationDesktop ||
				e.dataset.animateDurationMobile ||
				e.dataset.animateDuration ||
				"2";

			const stagger =
				e.dataset.animateStaggerDesktop ||
				e.dataset.animateStaggerMobile ||
				e.dataset.animateStagger ||
				"0.1";

			// Calculate if element is above the fold
			const elementTop = e.getBoundingClientRect().top + window.scrollY;
			const isAboveFold = elementTop < window.innerHeight;

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: e,
					start: isAboveFold ? "top bottom" : "top 90%",
				},
			});

			tl.fromTo(e, {
				autoAlpha: 0,
				scale: 1.2,
				filter: "blur(5vw)"
			}, {
				autoAlpha: 1,
				scale: 1,
				filter: "blur(0vw)",
				ease: "power4.out",
				duration: duration,
				stagger: stagger,
				delay: delay,
			});
		});
	}
}